import { API_URL } from '../../../utils/config';

// eslint-disable-next-line import/prefer-default-export
export const COMPLETED_SITES_URL = `${API_URL}/scrape`;
